import { ERoomsCount } from 'shared/types/marketTrends';
import { sendAnalytics } from 'shared/utils/analytics';

const ROOMS_COUNT_ANALYTICS_MAP: Partial<Record<ERoomsCount, string>> = {
  [ERoomsCount.FourPlusRooms]: 'fourplus',
  [ERoomsCount.OneRoom]: 'one',
  [ERoomsCount.Studio]: 'studio',
  [ERoomsCount.ThreeRooms]: 'three',
  [ERoomsCount.TwoRooms]: 'two',
};

export const trackRoomsCountFilterChange = (roomsCount: ERoomsCount) =>
  sendAnalytics({
    action: 'Click',
    label: 'dynamic_rooms_count',
    page: {
      extra: {
        roomscount: roomsCount === ERoomsCount.All ? null : ROOMS_COUNT_ANALYTICS_MAP[roomsCount],
      },
    },
  });
